<template>
	<div id="app" v-touch:tap='onClick' class="w-full h-full">
		<div class="app-content w-full h-full flex flex-col">
			<div class="top-content flex flex-col">
				<div class="portrait-top-banner hide-landscape">
					<WFBanner template="default" container="screensaver-portrait" :playOnBoot="true"
						@clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
				</div>
				<div class="header-bar w-full bg-lilla flex flex-space-evenly">
					<Icon name="logo" />
					<WFClock format="HH:mm" />
					<div class="flex-spacer"></div>
					<Icon name="clock" />
					<div class="opening-hours" v-html="openingHours"></div>
					<div class="flex-spacer"></div>
				</div>
			</div>
			<div class="content">
				<div class="map-area-container" :class="{ 'map-search-visible': searchVisible }">
					<WFMap project="f77f3630755f36959fbea9d174ac8ca5" :class="{ 'map-popup-open': isPOIPopupVisible() }"
						@poiClicked="onMapPOIClick" @onTouch="onClick" @loaded="mapLoaded" ref="map" />
					<div class="map-overlay absolute">
						<div class="map-overlay-left">
							<div class="map-menu">
								<button class="btn btn-border" @click="toggleTingmargid">
									<Icon name="ting" /><label data-translation-element="tingmargid">Tingmärgid</label>
								</button>
								<div class="tingmargid" :class="{ 'active': tingmargidOpen }">
									<div class="ting-header" data-translation-element="tingmargid">Tingmärgid</div>
									<ul>
										<li>
											<Icon name="info" /><label
												data-translation-element="ting-infolett">Infolett</label>
										</li>
										<li>
											<Icon name="wc" /><label data-translation-element="ting-wc">Tualett</label>
										</li>
										<li>
											<Icon name="lift" /><label data-translation-element="ting-lift">Lift</label>
										</li>
										<li>
											<Icon name="eskalaator" /><label
												data-translation-element="ting-eskalaator">Eskalaator</label>
										</li>
										<li>
											<Icon name="trepp" /><label
												data-translation-element="ting-trepp">Trepp</label>
										</li>
										<li>
											<Icon name="atm" /><label
												data-translation-element="ting-atm">Pangaautomaat</label>
										</li>
										<li>
											<Icon name="joogivesi" /><label
												data-translation-element="ting-joogivesi">Joogiveekraan</label>
										</li>
										<li>
											<Icon name="parkla" /><label
												data-translation-element="ting-parkla">Parkla</label>
										</li>
										<li>
											<Icon name="buss" /><label data-translation-element="ting-buss">Buss</label>
										</li>
										<li>
											<Icon name="tramm" /><label
												data-translation-element="ting-tramm">Tramm</label>
										</li>
										<li>
											<Icon name="rong" /><label data-translation-element="ting-rong">Rong</label>
										</li>
									</ul>
									<div class="ting-header" data-translation-element="ting-puhkealad">Puhkealad</div>
									<div>
										<Icon name="puhkealad"></Icon>
									</div>
								</div>
							</div>
						</div>
						<div class="map-overlay-right">
							<WFFloorsMenu class="map-menu" :currentFloor="currentFloor" :hideWhenSingleFloor="true" />
							<WFShortcutsMenu class="map-menu" :showLabel="false" @clicked="showShortcut" />
						</div>
					</div>
					<div class="map-shadow" :class="{ 'active': mapShadow }" @click="closeShadow">
						<div v-show="showFloorText">
							<label class="shadowText">{{ mapFloorText }}</label>
							<label data-translation-element="just-floor">korrus</label>
						</div>
					</div>
					<div id="poi-popup" ref="poiPopup" v-show="isPOIPopupVisible()">
						<div class="poi-popup-content" v-if="popupPOI">
							<label class="title" target="_new">{{ popupPOI.getName(language) }}</label>
							<button class="btn btn-border btn-first" @click="onMapPOIClick(popupPOI)">
								<Icon name="info"></Icon><label data-translation-element="info">Info</label>
							</button>
							<button class="btn btn-border" @click="showPath(popupPOI)">
								<Icon name="path"></Icon><label data-translation-element="path">Teekond</label>
							</button>
						</div>
						<div class="pin-down"></div>
					</div>
				</div>

				<div class="menus bg-white">
					<div class="menus-container flex flex-col">
						<TopBar class="menus-top drop-shadow" :class="{ 'search-visible': !topBarSearch }"
							@search="showSearch" @closeSearch="onSearchClose" @openOverlay="openOverlay"
							@openTopics="openTopics" :searchbar="topBarSearch" :active="activeTab"
							:searchVisible="searchVisible" @searchinput="setSearchInput"></TopBar>
						<div class="menus-bottom flex-1 flex">
							<div class="menus-leftside"
								:class="{ 'active': activeTab == 'topics', 'up-shadow': landscape }">
								<WFScrollableArea>
									<WFGroupsMenu @clicked="onGroupMenuClick" :currentGroup="currentGroup" :parent="8" :az="true">
										<template v-slot:prepend>
											<li class="wf-list-item" :class="{ 'active': azActive }"
												data-translation-element="az" @click="filterAZ">A-Z</li>
										</template>
									</WFGroupsMenu>
								</WFScrollableArea>
							</div>
							<div class="menus-rightside">
								<WFScrollableArea class="alphabet-scroll">
									<WFAlphabet :pois="pois" @clicked="filterChar" :overrideChar="overrideChar"
										:group="alphaGrouped" />
								</WFScrollableArea>
								<WFScrollableArea class="filtered-scroll poi-list" ref="filterscroll">
									<WFFilteredMenu :sortedPOIs="filteredPOIs" v-slot:default="slotProps">
										<div class="list-poi">
											<label class="poi-name" v-html="slotProps.poi.getName(language)"
												@click="onPOIClick(slotProps.poi)"></label>
											<button class="btn poi-floor"
												v-if="slotProps.poi.getFloor() && slotProps.poi.getFloor().names">
												<Icon name="floor" />
												<WFTranslate k="floor"
													:params="[slotProps.poi.getFloor().getName(language)]" />
											</button>
											<button class="btn btn-border" @click="onPOIClick(slotProps.poi)">
												<Icon name="info" />
												<WFTranslate k="info" />
											</button>
											<button class="btn btn-border" @click="showPath(slotProps.poi)">
												<Icon name="path" />
												<WFTranslate k="path" />
											</button>
										</div>
									</WFFilteredMenu>
								</WFScrollableArea>
								<div class="menus-search poi-list" :class="{ 'active': searchVisible }">
									<Search @showPath="showPath" @onPOIClick="onPOIClick" @close="onSearchClose"
										:showOutputField="!topBarSearch" :currentPOI="currentPOI" ref="search" />
								</div>
							</div>
						</div>
						<div class="landscape-top-banner hide-portrait">
							<WFBanner template="default" container="screensaver" :playOnBoot="true"
								@clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
						</div>
					</div>
					<Overlay :class="{ 'active': poiOpen && !landscape }" @close="closePOI"
						:title="currentPOI && currentPOI.getName(language)">
						<POI :poi="currentPOI" @showPath="showPath" @showOnMap="showOnMap" />
					</Overlay>
					<Overlay class="overlay-poi-landscape" :class="{ 'active': poiOpen && landscape }" @close="closePOI"
						:title="currentPOI ? currentPOI.getGroupNames(language)[0] : ''">
						<template v-slot:default>
							<POILandscape :poi="currentPOI" @close="closePOI" @showPath="showPath"
								@showOnMap="showOnMap" />
						</template>
						<template v-slot:header-right>
							<div class="overlay-header-poi">
								<div class="poi-floor" v-if="currentPOI">
									<Icon name="floor" /><label v-if="currentPOI.getFloor()"
										v-html="currentPOI.getFloor().getName(language) || ''"></label><label>.
										korrus</label>
								</div>
								<div class="poi-open" v-if="currentPOI && currentPOI.opening_hours">
									<Icon name="clock" /><label>{{ currentPOI.opening_hours }}</label>
								</div>
							</div>
						</template>
					</Overlay>
					<ContentOverlay :class="{ 'active': overlayOpen }" @close="closeOverlay"
						:title="getOverlayTitle(activeTab)" :banner="getBanner(activeTab)">
						<WFTabs ref="tabs" :activeTab="activeTab" animate="vertical">
							<WFTab name="uldinfo">
								<Uldinfo />
							</WFTab>
							<WFTab name="kinkekaart">
								<Kinkekaart @next="openOverlay('kinkekaart2')" />
							</WFTab>
							<WFTab name="kinkekaart2">
								<Kinkekaart2 />
							</WFTab>
							<WFTab name="parkimine">
								<div class="overlay-content-container">
									<WFPage slug="parkimine" :showName="!landscape" />
									<div class="overlay-image">
										<img :src="'./banners/parkimine.png'" />
									</div>
								</div>
							</WFTab>
							<WFTab name="puhkealad">
								<div class="overlay-content-container">
									<WFPage slug="puhkealad" :showName="!landscape" />
									<div class="overlay-image">
										<img :src="'./banners/puhkealad.png'" />
									</div>
								</div>
							</WFTab>
						</WFTabs>
					</ContentOverlay>
					<div class="menus-footer hide-landscape"></div>
				</div>
			</div>
		</div>
		<div id="screensaver" class="banners-screensaver hide-mobile" v-show="screensaver" @click="hideBanner()">
			<WFBanner template="default" container="screensaver" class="hide-portrait" @clicked="onBannerClick"
				@hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
			<WFBanner template="default" container="screensaver-portrait" class="hide-landscape"
				@clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
		</div>
	</div>
</template>

<script>
import { WFMap, WFFloorsMenu, WFGroupsMenu, WFScrollableArea, WFBanner, WFAlphabet, WFFilteredMenu, WFShortcutsMenu, WFTabs, WFTab, WFPage, WFClock } from '@3dwayfinder/wayfinder-vue-components'
import TopBar from './components/TopBar';
import Overlay from './components/Overlay';
import ContentOverlay from './components/ContentOverlay';
import POI from './components/POI';
import Uldinfo from './pages/Uldinfo';
import Kinkekaart from './pages/Kinkekaart';
import Kinkekaart2 from './pages/Kinkekaart2';
import POILandscape from './components/POILandscape';
import Search from './components/Search';
import { mapState } from 'vuex';

export default {
	name: 'app',
	components: {
		WFMap,
		WFFloorsMenu,
		WFGroupsMenu,
		WFBanner,
		WFScrollableArea,
		WFShortcutsMenu,
		WFAlphabet,
		WFClock,
		WFFilteredMenu,
		WFPage,
		TopBar,
		Overlay,
		ContentOverlay,
		POI,
		POILandscape,
		WFTabs,
		WFTab,
		Uldinfo,
		Kinkekaart,
		Kinkekaart2,
		Search,
	},
	data() {
		return {
			lastClick: false,
			screensaver: false,
			hasScreensaver: false,
			menuActive: false,
			azActive: true,
			overlayImage: -1,
			poiOpen: false,
			overlayOpen: false,
			tingmargidOpen: false,
			currentGroup: null,
			searchVisible: false,
			qrURL: "https://clients.3dwayfinder.com/Ulemiste/?kiosk={kiosk}&map2DRotation={rot}",
			filteredPOIs: [],
			openingHours: "",
			activeTab: "",
			mapShadow: false,
			popupPOI: null,
			poiPopupVisible: false,
			currentVisible: false,
			mapFloorText: "",
			showFloorText: false,
			overrideChar: ""
		}
	},
	computed: {//yahLogo
		...mapState('wf', ['maxInActivity', 'currentFloor', 'mobile', 'pois', 'language', 'landscape', 'portrait']),
		...mapState(['currentPOI']),
		topBarSearch() {
			console.log('topBarSearch', !this.landscape, (this.landscape && !this.searchVisible && this.activeTab == ""), this.searchVisible, this.activeTab)
			return !this.landscape || (this.landscape && !this.searchVisible && this.activeTab == "");
		},
		alphaGrouped() {
			if (this.language == "ru") {
				return 'гк'
			}

			return 'wxyzõöü';
		}
	},
	mounted() {
		this.resize();

		window.onresize = () => {
			this.resize();
		}
	},
	watch: {
		pois() {
			console.log('pos', this.$wayfinder.pois)
			this.filterPOIs(this.pois);
		}
	},
	methods: {
		setSearchInput(input) {
			if (this.$refs.search && input) {
				this.$refs.search.setOutput(input);
			}
		},
		filterPOIs(pois) {
			pois = pois.filter(p => {
				return p && p.getShowInMenu() && p.getName(this.language) !== ""
			});
			this.filteredPOIs = [];
			this.filteredPOIs = pois.map(p => {
				return Object.freeze(p);
			});
			this.$store.dispatch('wf/SET_FILTERED_POIS', this.filteredPOIs);
		},
		onClick() {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();

			this.lastClick = setTimeout(() => {
				this.reset();
				this.$refs.map.reset();
			}, this.maxInActivity * 1000);
			return false;
		},
		filterAZ() {
			this.filterPOIs(this.pois);
			this.azActive = true;
			this.mapShadow = false;
			this.$store.dispatch('wf/SET_CURRENT_GROUP', { id: -1 });
			this.currentGroup = null;
			this.overrideChar = "nochar";
			if (this.$refs.filterscroll)
				this.$refs.filterscroll.reset();
		},
		changeTab(tab) {
			this.currentTab = tab;
		},
		onGroupMenuClick(group) {
			this.azActive = false;
			this.mapShadow = false;
			//this.$store.dispatch('wf/SET_CURRENT_GROUP', Object.freeze(group));
			this.currentGroup = Object.freeze(Object.assign({}, group));
			this.activeTab = "";
			this.mapShadow = false;
			this.searchVisible = false;
			this.overrideChar = "nochar";
			this.filterPOIs(group.pois);
		},
		filterChar(char, pois) {
			this.overrideChar = char;
			this.filterPOIs(pois);
			this.$nextTick(() => {
				this.$nextTick(() => {
					if (this.$refs.filterscroll)
						this.$refs.filterscroll.reset();
				});
			});

		},
		onMapPOIClick(poi) {
			this.$wayfinder.clearHighlights();

			if (poi && poi.getShowInMenu()) {
				this.$store.dispatch('setPOI', Object.freeze(poi));
				this.onPOIClick(poi, true);

				this.$wayfinder.setHighlights([poi]);
				if (poi.getNode()) {
					console.log('floor', poi.getFloor())
					this.$wayfinder.showFloor(poi.getFloor())
					this.popupPOI = Object.freeze(poi);
					this.showPOIPopup(poi);
					this.currentVisible = true;
				}

				if (this.landscape) {
					this.changeTab('poi-info');
				}
			}
		},
		clearShortcut() {
			this.$wayfinder.clearPath();
			this.$wayfinder.clearHighlights();
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.setDehighlightOverlay(false);
		},
		showShortcut(nearest, group) {
			this.clearShortcut();
			let overlay = "";
			switch (group.id) {
				case "7":
					overlay = "parkimine";
					break;
				case "6":
					overlay = "puhkealad";
					break;
				default:
					if (nearest) {
						if (this.$wayfinder.options.mapRotate) {
							let speed = 300;
							let scope = this;
							this.$wayfinder.setRotation(parseInt(this.$wayfinder.options.mapRotate), speed, function () {
								setTimeout(() => {
									scope.$wayfinder.showPath(nearest.node, nearest)
								}, speed)
							});
						}
						else {
							this.$wayfinder.showPath(nearest.node, nearest);
						}
					}
					break;
			}

			if (overlay != "") {
				this.$nextTick(() => {
					this.openOverlay(overlay, true);
					this.$wayfinder.setDehighlightOverlay(true);
					this.$wayfinder.setDisplaying(group.pois);
				})
			}

		},
		showSearch() {
			this.searchVisible = true;
		},
		onPOIClick(poi) {
			this.$store.dispatch('setPOI', Object.freeze(poi));
			this.popupPOI = Object.freeze(poi);

			this.poiOpen = true;
			this.activeTab = "";
			this.mapShadow = false;
			this.$wayfinder.clearHighlights();
			this.$wayfinder.setHighlights([poi]);
			this.showPOIPopup(poi);
			console.log('wf', this.$wayfinder)
		},
		openTopics() {
			this.searchVisible = false;
			this.overlayOpen = false;
			this.poiOpen = false;
			this.mapShadow = false;
			this.activeTab = this.activeTab == "topics" ? "" : "topics";
		},
		closePOI() {
			this.poiOpen = false;
			this.mapShadow = false;
		},
		closeShadow() {
			this.poiOpen = false;
			this.mapShadow = false;
			this.overlayOpen = false;
		},
		onSearchPOIClick(poi) {
			if (poi) {
				this.onPOIClick(poi);

			}
		},
		showPath(poi) {
			this.poiPopupVisible = false;

			if (this.$wayfinder.options.mapRotate) {
				let speed = 300;
				let scope = this;
				this.$wayfinder.setRotation(parseInt(this.$wayfinder.options.mapRotate), speed, function () {
					setTimeout(() => {
						scope.$wayfinder.showPath(poi.getNode(), poi)
					}, speed)
				});
			}
			else {
				this.$wayfinder.showPath(poi.getNode(), poi)
			}

			this.$wayfinder.clearHighlights();
			this.$wayfinder.setHighlights([poi]);
		},
		showOnMap(poi) {
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.clearHighlights();
			if (poi) {
				this.$wayfinder.showFloor(poi.getFloor());
				this.$wayfinder.clearPath()
				this.$wayfinder.setHighlights([poi]);
				this.$wayfinder.setDisplaying([poi]);
				this.showPOIPopup(poi);
			}
		},
		onSearchClose() {
			if (this.$refs.search)
				this.$refs.search.resetValues();
			this.searchVisible = false;
		},
		reset() {
			let preset = this.$options.data();
			delete preset["openingHours"];
			delete this.$data;
			Object.assign(this.$data, { ...preset });
			this.$store.dispatch('wf/SET_RESET');
			this.filterAZ();
			this.clearShortcut();
			if (this.$wayfinder.options.mapRotate) {
				this.$wayfinder.setRotation(0);
			}

			if (this.$refs.map) {
				setTimeout(() => {
					this.$refs['map'].pause();
				}, 1000)
			}
		},
		resize() {
			let _l = window.matchMedia("(orientation: landscape)");
			let _pm = window.matchMedia("(max-height: 1024px) and (orientation: portrait)");
			let _lm = window.matchMedia("(max-width: 1024px) and (orientation: landscape)");
			let landscape = _l ? _l.matches : false;
			let mobile = (_pm ? _pm.matches : false) || (_lm ? _lm.matches : false);
			this.$store.dispatch('wf/SET_LANDSCAPE', landscape);
			this.$store.dispatch('wf/SET_MOBILE', mobile);
		},
		doSomething() { },
		onBannerClick(/*frame, container*/) {
			this.screensaver = false;
			this.$refs['map'].run();
		},
		toGroups() {
			this.changeTab('groups');
		},
		hideBanner() {
			this.screensaver = false;
		},
		showPOIPopup(poi) {
			this.popupPOI = Object.freeze(poi);
			let position = this.$wayfinder.getScreenPosition(poi);
			let offset = (this.$wayfinder.settings.getFloat("poi.2d.icon-size", 24, poi) - 24) / 2;
			this.$refs.poiPopup.style.left = position[0] + "px";
			this.$refs.poiPopup.style.top = position[1] - offset + "px";
			this.poiPopupVisible = true;
		},
		hidePOIPopup() {
			this.poiPopupVisible = false;
		},
		isPOIPopupVisible() {
			return (this.$wayfinder && this.popupPOI && this.poiPopupVisible && this.popupPOI.getNode().floor == this.$wayfinder.getCurrentFloor())
		},
		mapLoaded() {
			this.$refs['map'].run();

			if (this.$wayfinder) {
				this.$wayfinder.options.pathDisplayInstructions = false;
			}

			this.qrURL = this.qrURL.replace("{kiosk}", this.$wayfinder.getKiosk());
			this.qrURL = this.qrURL.replace("{rot}", 0);
			/*this.$store.dispatch('loadExternal', this.$wayfinder).then(() => {
				console.log('map.update');
				this.$refs['map'].update();
				this.$wayfinder.resize();

			});*/
			this.openingHours = this.$wayfinder.translator.get("opening-hours", "").replaceAll("%0","<b>").replaceAll("%1","</b>");

			this.$wayfinderApp.loadPages();

			this.$wayfinder.events.on("map-update", () => {
				if (this.poiPopupVisible && this.popupPOI) {
					this.showPOIPopup(this.popupPOI);
				}
			});

			this.$wayfinder.events.on("floor-change", (floor) => {
				if (this.poiPopupVisible && this.popupPOI && this.popupPOI.floor == floor) {
					this.showPOIPopup(this.popupPOI);
				}
				else {
					this.poiPopupVisible = false;
				}
			});

			this.$wayfinder.events.on("floor-change-before", (floor) => {
				if (this.pathAnimation) {
					this.mapShadow = true;
					this.mapFloorText = floor.getName(this.language);
					setTimeout(() => {
						this.mapShadow = false;
						this.mapFloorText = "";
						this.showFloorText = false;
					}, 2000)
				}
			});

			this.$wayfinder.events.on("path-start", () => {
				console.log('path-start');
				this.pathAnimation = true;
				this.showFloorText = true;
			});

			this.$wayfinder.events.on("path-finished", () => {
				console.log('path-end');
				this.pathAnimation = false;
				this.showFloorText = false;
			});

			this.$wayfinder.events.on("map-touch", () => {
				this.poiPopupVisible = false;
				this.tingmargidOpen = false;
				this.mapShadow = false;
				this.clearShortcut();
				this.overlayOpen = false;
			});
		},
		hasBanners(has) {
			this.hasScreensaver = has;
		},
		openOverlay(name, mapShadow) {
			this.clearShortcut();
			if (this.activeTab != name) {
				this.overlayOpen = true;
				this.searchVisible = false;
				this.activeTab = name;
				this.mapShadow = !mapShadow;
			}
			else {
				this.closeOverlay();
			}
		},
		closeOverlay() {
			this.overlayOpen = false;
			this.mapShadow = false;
			this.activeTab = "";
		},
		openBrowser() {
			this.browserOpen = true;
		},
		closeBrowser() {
			this.browserOpen = false;
		},
		toggleTingmargid() {
			this.tingmargidOpen = !this.tingmargidOpen;
		},
		translate(key, params) {
			return this.$wayfinder.translator.get(key, params)
		},
		getBanner(tab) {
			let url = "";
			switch (tab) {
				case "uldinfo":
					url = "./banners/uldinfo.jpg"
					break;
				case "kinkekaart":
					url = "./banners/kinkekaart.jpg"
					break;
				case "kinkekaart2":
					if (this.landscape)
						url = "./banners/kinkekaart.jpg"
					break;
			}

			return url;
		},
		getOverlayTitle(tab) {
			if (this.$wayfinder) {
				return this.$wayfinder.translator.get('sisu-pealkiri-' + tab);
			}
			else {
				return "";
			}
		}
	}
};
</script>

<style lang="less">
@import 'css/styles';
@import 'css/responsive';
</style>
